<div class="product-settings">
    <div>
        <span class="product-title">
            {{ updatedProduct.productLineName }}
        </span>
        <span *ngIf="isProductWhitelisted" class="whitelisted-product-title"
            >Please unpublish the product to edit any disabled fields</span
        >

        <span class="error-text" *ngIf="isError">
            <span>{{ errorMessage }}</span>
        </span>
    </div>

    <div class="settings-container">
        <div
            class="toggle-item"
            *ngFor="let setting of editableSettings"
            [class.disabled-toggle]="
                (setting === couponsEnabled || setting === serviceFee) && updatedProduct.type === productTypes.TOP_UP
            "
        >
            <mat-slide-toggle
                [disabled]="
                    (isProductWhitelisted && setting === serviceFee)
                    || ((setting === couponsEnabled || setting === serviceFee)
                        && updatedProduct.type === productTypes.TOP_UP)
                "
                color="warn"
                [(ngModel)]="updatedProduct[setting]"
            ></mat-slide-toggle>
            <span class="toggle-label">{{ displayNames[setting] || setting }}</span>
        </div>
    </div>

    <div
        [class.disabled]="isProductWhitelisted"
        [formGroup]="serviceFeeForm"
        *ngIf="updatedProduct.serviceFee !== false && !(updatedProduct.type === productTypes.TOP_UP)"
        class="service-fee-config"
    >
        <span class="title">Service Fee Configuration</span>

        <div class="form-row">
            <mat-label class="form-label">Type <span class="required-indicator">*</span></mat-label>
            <div>
                <mat-radio-group aria-label="Select an option" formControlName="type">
                    <mat-radio-button class="radio-btn" [value]="serviceFeeType.FIXED">Fixed Amount</mat-radio-button>
                    <mat-radio-button class="radio-btn" [value]="serviceFeeType.PERCENTAGE"
                        >Percentage</mat-radio-button
                    >
                </mat-radio-group>
            </div>
        </div>

        <div class="form-row" *ngIf="feeType?.value === serviceFeeType.FIXED">
            <mat-label class="form-label align-text">Amount (CHF) <span class="required-indicator">*</span></mat-label>
            <div class="form-field">
                <mat-form-field appearance="outline">
                    <input matInput formControlName="amount" placeholder="000.00" />
                    <mat-error *ngIf="amount?.hasError('invalidNumber')">Must be a valid number</mat-error>
                    <mat-error *ngIf="amount?.hasError('required')">Amount is required </mat-error>
                    <mat-error *ngIf="amount?.hasError('min')">Must be positive </mat-error>
                    <mat-error *ngIf="amount?.hasError('decimals')">Only 2 decimal places allowed </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="form-row" *ngIf="feeType?.value === serviceFeeType.PERCENTAGE">
            <mat-label class="form-label align-text">Percentage % <span class="required-indicator">*</span></mat-label>
            <div class="form-field">
                <mat-form-field appearance="outline">
                    <input matInput formControlName="amount" placeholder="100" />
                    <mat-error *ngIf="amount?.hasError('required')">Percentage is required </mat-error>
                    <mat-error *ngIf="amount?.hasError('min')">Must be positive </mat-error>
                    <mat-error *ngIf="amount?.hasError('max')">Cannot exceed 100% </mat-error>
                    <mat-error *ngIf="amount?.hasError('decimals')">Only 2 decimal places allowed </mat-error>
                    <mat-error *ngIf="amount?.hasError('invalidNumber')">Must be a valid number</mat-error>
                </mat-form-field>
            </div>
        </div>

        <div formGroupName="text" class="form-row">
            <mat-label class="form-label align-text"
                >Service Fee Text <span class="required-indicator">*</span>
                <mat-icon [matTooltip]="HTML_IS_NOT_ALLOWED" matTooltipPosition="above" class="info-icon"
                    >info</mat-icon
                >
            </mat-label>
            <div class="form-field">
                <mat-form-field appearance="outline">
                    <mat-label>English</mat-label>
                    <input matInput formControlName="en-us" />
                    <mat-error *ngIf="text.get('en-us')?.hasError('required')">English text is required </mat-error>
                    <mat-error *ngIf="text.get('en-us')?.hasError('maxlength')"
                        >Max length is {{ MAX_TEXT_LENGTH }} chars
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>German</mat-label>
                    <input matInput formControlName="de-ch" />
                    <mat-error *ngIf="text.get('de-ch')?.hasError('required')">German text is required </mat-error>
                    <mat-error *ngIf="text.get('de-ch')?.hasError('maxlength')"
                        >Max length is {{ MAX_TEXT_LENGTH }} chars
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>French</mat-label>
                    <input matInput formControlName="fr-ch" />
                    <mat-error *ngIf="text.get('fr-ch')?.hasError('required')">French text is required </mat-error>
                    <mat-error *ngIf="text.get('fr-ch')?.hasError('maxlength')"
                        >Max length is {{ MAX_TEXT_LENGTH }} chars
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Italian</mat-label>
                    <input matInput formControlName="it-ch" />
                    <mat-error *ngIf="text.get('it-ch')?.hasError('required')">Italian text is required </mat-error>
                    <mat-error *ngIf="text.get('it-ch')?.hasError('maxlength')"
                        >Max length is {{ MAX_TEXT_LENGTH }} chars
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="actions-container">
        <button mat-button class="cancel-button" (click)="onNoClick()">CANCEL</button>
        <button
            mat-button
            class="save-button"
            [disabled]="serviceFeeForm.invalid && updatedProduct.serviceFee === true"
            (click)="onYesClick()"
        >
            SAVE
        </button>
    </div>
</div>
